import styled from "styled-components";
import { $SearchPageTemplate } from "../styles";

const $TypeStoreNumber = styled($SearchPageTemplate)``;

export default $TypeStoreNumber;
